import {
  getAllDarklyFlags,
  createDarklyClient,
  closeDarklyClient,
  switchDarklyContextToAnonymous,
  onDarklyFeatureFlagChange,
} from '@/utils/launchdarkly'
const subscribedFeatureFlags = new Set()

const updateFlags = context => {
  const newFlags = getAllDarklyFlags()
  context.commit('FEATURE_FLAGS_UPDATED', { ...newFlags })
}

const cleanFlagsStore = context => {
  context.commit('FEATURE_FLAGS_UPDATED', {})
}

const registerFeatureFlagSubscriptions = context => {
  const scopedFlags = Object.keys(context.state).filter(flag => flag !== 'flags')
  const dynamicFlags = Object.keys(context.state.flags || {})
  const flagsToSubscribe = new Set([...scopedFlags, ...dynamicFlags])

  flagsToSubscribe.forEach(flag => {
    if (subscribedFeatureFlags.has(flag)) return

    onDarklyFeatureFlagChange(flag, () => {
      updateFlags(context)
    })
    subscribedFeatureFlags.add(flag)
  })
}

const actions = {
  updateFeatureFlags: async context => {
    try {
      updateFlags(context)
    } catch (error) {
      cleanFlagsStore(context)
    }
  },
  initializeDarkly: async context => {
    try {
      const currentUser = context.rootGetters['users/getCurrentUser'] || {}
      const isAuthenticated = !!context.rootGetters['users/getUserToken']
      const darklyClient = await createDarklyClient({
        isAuthenticated,
        currentUser,
      })
      if (!darklyClient) {
        cleanFlagsStore(context)
        return
      }

      await context.dispatch('updateFeatureFlags')
      registerFeatureFlagSubscriptions(context)
    } catch (error) {
      cleanFlagsStore(context)
    }
  },
  closeDarkly: async context => {
    try {
      await closeDarklyClient()
    } finally {
      subscribedFeatureFlags.clear()
      cleanFlagsStore(context)
    }
  },
  switchDarklyContextToAnonymous: async context => {
    try {
      await switchDarklyContextToAnonymous()
      updateFlags(context)
    } catch (error) {
      cleanFlagsStore(context)
    }
  },
}

export default actions
